module.exports = __webpack_public_path__ + "img/Moonbase_Install.3cb7437f.png";